import moment from "moment";
import { Badge, CopyButton } from "../../../../../components";
import { appConfig } from "../../../../../configs";

import { IViewInvoice } from "../../../../../interfaces-and-types";
import {
  formatAsCurrency,
  getPaymentLinkStatusIndicator,
  truncateStringWithEllipsis,
} from "../../../../../utils";
import { LinkUrlCopyDisplay } from "../../../../PaymentLinks/LinkUrlCopyDisplay";

export const customerInvoicesDisplayFormatter = (item: IViewInvoice) => {
  const statusIndicator = getPaymentLinkStatusIndicator(item);

  return {
    ...item,
    link_url: <LinkUrlCopyDisplay link={item.link_url_with_hostname} />,
    amount: (
      <strong>
        {item.currency} {formatAsCurrency(item.amount)}
      </strong>
    ),
    status: (
      <Badge
        text={statusIndicator.statusText}
        statusColor={statusIndicator.statusType}
      />
    ),
    reference: (
      <div className="flex-container justify-content--start align-items--center no-wrap">
        <div className="transaction-id-text modal-header--title">
          <span title={item.tx_ref}>
            {truncateStringWithEllipsis(item.tx_ref, 8)}
          </span>
        </div>
        <div className="copy-button--container ml-3">
          <CopyButton
            name="copy-reference-button"
            stringToCopy={item.tx_ref}
            iconDescription="copy reference"
            className="copy-btn"
          />
        </div>
      </div>
    ),
    date: (
      <span className="date--oneline">
        {moment(item.created_at).format(appConfig.dateTimeFormat)}
      </span>
    ),
    more: item.actions,
  };
};
